import { useMemo } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';

import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';
import {
    TRetailPagesConfigTag
} from '@interlayer/js/components/system/TagManager/buzz/types';

export const useGetRetailConfigTag = () => {
    const configTags = useAppSelector(prop('tags'));

    const tag = configTags
        .find(tagItem => tagItem.tagTypeId === CONFIG_TAG_TYPE.retailPagesConfig) as TRetailPagesConfigTag;

    const currentPathname = window.Playtech?.Variables?.currentRetailURLOverride
        ? window.Playtech?.Variables?.currentRetailURLOverride
        : window.location.pathname;

    return useMemo(() => {
        if (!tag) {
            return null;
        }

        return tag.config.retailFlows.find(flow =>
            flow.welcomePageURL.toLowerCase() === currentPathname.toLowerCase() ||
            flow.registrationURL?.toLowerCase() === currentPathname.toLowerCase() ||
            flow.upgradeURL?.toLowerCase() === currentPathname.toLowerCase()
        );
    }, [currentPathname, tag]);
};
